module.exports = __webpack_public_path__ + "fonts/iconfont.c21936ca.eot";